<template>
    <div class="banner-wrapper bg-image-to-load" v-img-responsive="{ device: device, images: images }">
        <div class="background-overlay"></div>
        <slot></slot>

        <div class="line-wrapper" v-if="line">
            <div class="line"><span></span></div>
        </div>
    </div>
</template>

<script setup>
import { useStore } from 'vuex';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { computed, onBeforeUnmount, onMounted } from 'vue';
import vImgResponsive from '@/directives/v-img-responsive';

gsap.registerPlugin(ScrollTrigger);

const store = useStore();

const props = defineProps({
    images: {
        type: Object,
        required: true
    },

    line: {
        type: Boolean,
        default: true
    }
});

const animations = [];

const device = computed(() => store.state.device);

onMounted(() => {
    setTimeout(() => {
        gsap.set('.banner-wrapper .line span', { height: '100%' });
        gsap.set('.banner-wrapper h1, .banner-wrapper .btn', { scale: 1, opacity: 1 });
        gsap.set('.banner-wrapper .background-overlay', { opacity: 0.3 });

        animations.push(gsap.to('.banner-wrapper .line span', {
            scrollTrigger: {
                trigger: '.main-wrapper',
                start: 'top bottom',
                end: 'top 70%',
                scrub: true,
            },
            height: '0%'
        }));

        animations.push(gsap.to('.banner-wrapper h1, .banner-wrapper .btn', {
            scrollTrigger: {
                trigger: '.main-wrapper',
                start: 'top bottom',
                end: 'top 50%',
                scrub: true,
            },
            scale: 0.9,
            opacity: 0
        }));

        animations.push(gsap.to('.banner-wrapper .background-overlay', {
            scrollTrigger: {
                trigger: '.main-wrapper',
                start: 'top bottom',
                end: 'top top',
                scrub: true,
            },
            opacity: 1,
        }));
    }, 0);
});

onBeforeUnmount(() => {
    animations.forEach((animation) => {
        animation.kill();

        if (animation.scrollTrigger) {
            animation.scrollTrigger.kill();
        }

        animation = null;
    });

    animations.length = 0;
});
</script>
